import React, { useState } from "react";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useTranslation } from "react-i18next";

export const SUPPORTED_LOCALES = [
  { code: "pt-BR", label: "Português (Brasil)", flag: "🇧🇷", short: "BR" },
  { code: "pt-PT", label: "Português (Portugal)", flag: "🇵🇹", short: "PT" },
  { code: "en-US", label: "English", flag: "🇺🇸", short: "EN" },
  { code: "es-ES", label: "Español", flag: "🇪🇸", short: "ES" },
  { code: "fr-FR", label: "Français", flag: "🇫🇷", short: "FR" },
];

// Botão discreto; o idioma inicial vem de i18next (navegador) e o utilizador pode substituí-lo.
export default function LanguageSelector({ small = false, dark = false }) {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const current = SUPPORTED_LOCALES.find((x) => x.code === (i18n.resolvedLanguage || i18n.language)) || SUPPORTED_LOCALES[0];
  const close = () => setAnchorEl(null);
  const select = (code) => {
    close();
    void i18n.changeLanguage(code);
  };

  return <>
    <Tooltip title={`Idioma: ${current.label}`}>
      <IconButton
        size="small"
        aria-label={`Selecionar idioma. Atual: ${current.label}`}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{ color: dark ? "#f8fafc" : "#475569", border: "1px solid", borderColor: dark ? "rgba(255,255,255,.22)" : "#e2e8f0", borderRadius: 2, minWidth: small ? 46 : 56, height: 36, px: 0.7 }}
      >
        <Typography component="span" aria-hidden="true" sx={{ fontSize: 19, lineHeight: 1 }}>{current.flag}</Typography>
        <KeyboardArrowDownRoundedIcon sx={{ fontSize: 16, ml: 0.2 }} />
      </IconButton>
    </Tooltip>
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}
      MenuListProps={{ "aria-label": "Idioma da aplicação" }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{ sx: { minWidth: 220, maxWidth: "calc(100vw - 32px)", mt: 0.75, borderRadius: 2 } }}>
      {SUPPORTED_LOCALES.map(({ code, label, flag }) => (
        <MenuItem key={code} selected={code === current.code} onClick={() => select(code)}>
          <ListItemIcon sx={{ minWidth: 32, fontSize: 18 }}>{flag}</ListItemIcon>
          <ListItemText primary={label} />
        </MenuItem>
      ))}
    </Menu>
  </>;
}
